<div class="pd25 border-radius white-bg relative modal center-unknown-height-width shadow-wide z-index">
	<ng-content select="[modalHeader]"></ng-content>
	<ng-content select="[modalContent]"></ng-content>
	<ng-content select="[modalFooter]"></ng-content>
</div>
<div (click)="onOutsideClick()" class="modal__background"></div>
